/**
 * WD-9 — Publish CMS version.
 * US-A09 AC4: publishing Privacy or Terms records a new version with an
 * effective date.
 */
import { DatePicker, Form, Input } from 'antd'
import type { Dayjs } from 'dayjs'
import dayjs from 'dayjs'
import { useState } from 'react'
import { useAdminTranslate } from '@/providers/i18n-provider'
import { ConfirmDialog } from './ConfirmDialog'

export interface PublishCmsVersionDialogProps {
  open: boolean
  pageLabel: string
  currentVersion: string
  onConfirm: (payload: { version: string; effectiveDate: string }) => Promise<void> | void
  onCancel: () => void
}

export const PublishCmsVersionDialog = ({
  open,
  pageLabel,
  currentVersion,
  onConfirm,
  onCancel,
}: PublishCmsVersionDialogProps) => {
  const translate = useAdminTranslate()
  const [version, setVersion] = useState('')
  const [effectiveDate, setEffectiveDate] = useState<Dayjs>(dayjs())

  return (
    <ConfirmDialog
      open={open}
      title={translate('admin.dialogs.publishCms.title', { page: pageLabel })}
      description={translate('admin.dialogs.publishCms.description', { version: currentVersion })}
      confirmLabel={translate('admin.dialogs.publishCms.confirm')}
      onConfirm={() =>
        onConfirm({ version: version.trim(), effectiveDate: effectiveDate.toISOString() })
      }
      onCancel={onCancel}
    >
      <Form layout="vertical">
        <Form.Item
          label={translate('admin.dialogs.publishCms.versionLabel')}
          required
          help={translate('admin.dialogs.publishCms.versionHelp')}
        >
          <Input value={version} onChange={event => setVersion(event.target.value)} />
        </Form.Item>
        <Form.Item label={translate('admin.dialogs.publishCms.effectiveDate')} required>
          <DatePicker
            value={effectiveDate}
            onChange={value => setEffectiveDate(value ?? dayjs())}
            format="DD/MM/YYYY"
          />
        </Form.Item>
      </Form>
    </ConfirmDialog>
  )
}
